import {UserPermission} from '@interface/user-permission';
import {UserPermissionManager} from './user-permission';
import {CartB2cModalComponent} from '../../../components/cart-b2c-modal/cart-b2c-modal.component';
import {CartLabels} from '../proforma-cart-labels/cart-labels';

class PublicPermissionClass implements UserPermission {
  readonly userRole = undefined;
  readonly labelRole = '';
  readonly isAuthenticated = false;

  readonly canRequestEto = false;
  readonly isDefaultUntaxedPrice = false;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = false;

  readonly hasMoreClients = false;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = false;
  readonly canHaveManyEditableProforma = false;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = false;
  readonly crmSectionsVisible = [];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = CartLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = CartB2cModalComponent;

  readonly canAssignCrmTaskToOthers = false;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = false;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = false;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = false;

  readonly composerAllowed = false;
}

const PublicPermission = new PublicPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(PublicPermission);
UserPermissionManager.instance.assignPublicPermission(PublicPermission);
